module.exports = __webpack_public_path__ + "assets/img/26_828.1221d0c0.jpg";